__turbopack_context__.v({
  "button": "styles-module-scss-module__1mC9UG__button",
  "root": "styles-module-scss-module__1mC9UG__root",
  "rootDarkMode": "styles-module-scss-module__1mC9UG__rootDarkMode",
  "shareUrl": "styles-module-scss-module__1mC9UG__shareUrl",
});
